import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import LineLightbulbIcon from 'LuxKit/Icons/line/LineLightbulbIcon'
import Clickable from 'components/Common/Clickable'

const Container = styled(Clickable)`
  width: ${rem(240)};
  min-height: ${rem(110)};
  flex-shrink: 0;

  > * {
    height: 100%;
  }
`

interface Props {
  label: string
  selected?: boolean
  onClick: (label: string) => void
}

export default function ChatLandingSuggestedActionTile({ label, selected, onClick }: Props) {
  const intl = useIntl()

  const suggestedLabel = useMemo(() => intl.formatMessage({
    id: 'iYCT3qxU7SXxlQU7dk_0',
    defaultMessage: 'Suggested',
    description: 'Category label for suggested action tile on the chat landing page',
  }), [intl])

  const handleClick = useCallback(() => {
    onClick(label)
  }, [onClick, label])

  return (
    <Container onClick={handleClick}>
      <Sheet background="neutral-eight" border={selected ? 'neutral-one' : 'neutral-five'} borderRadius="L" padding={12}>
        <Group direction="vertical" gap={20} fullHeight>
          <CaptionTextBlock
            variant="small"
            weight="bold"
            format="uppercase"
            colour="neutral-three"
            startIcon={<LineLightbulbIcon size="XS" />}
          >
            {suggestedLabel}
          </CaptionTextBlock>
          <BodyText variant="medium" weight="normal" lineClamp={3}>
            {label}
          </BodyText>
        </Group>
      </Sheet>
    </Container>
  )
}
